import React, { useCallback, useEffect, useMemo, useState } from "react";
import Loading from "../../Extra/Loading";
import SAController from "./SAController";
import { useDispatch, useSelector } from "react-redux";
import { getSevenALoadingDetails } from "../../../redux-store/thunk/chart.thunk";
import CommodityWiseChart from "./7AComps/CommodityWiseChart";
import WagonYearWiseChart from "./7AComps/WagonYearWiseChart";
import CommodityCHWightWiseChart from "./7AComps/CommodityCHWightWiseChart";
import YearWiseCHWightChart from "./7AComps/YearWiseCHWeightChart";
import Wagon from "./7AComps/Wagon";
import CHWeight from "./7AComps/CHWeight";
import SummeryData from "./7AComps/SummeryData";
import SevenASummary from "./Seven A Summary/SevenASummary";
import CustomPageNevBtn from "../../Extra/CustomPageNevBtn";

const SevenALoadingMaster = () => {
  const dispatch = useDispatch();
  const [sevenAData, setSevenAData] = useState(null);
  const [moreData, setMoreData] = useState(null);
  const [activePage, setActivePage] = useState("CH Weight");
  const [FilteredSevenA, setFilteredSevenA] = useState(null);

  const [status, setStatus] = useState(null);
  const [yearsInData, setYearsInData] = useState(null);

  const [openStates, setOpenStates] = useState({
    Year: false,
    "Group Commodity": false,
    "Sub Group Commodity": false,
    Commodity: false,
    Month: false,
    "From Station": false,
    "To Station": false,
  });

  useEffect(() => {
    dispatch(getSevenALoadingDetails());
  }, [dispatch]);

  const { tempData, loading } = useSelector((state) => state.chart);
  useEffect(() => {
    setSevenAData(tempData);
  }, [tempData]);
  useEffect(() => {
    if (moreData) {
      setSevenAData((prev) => ({
        ...prev,
        data7A: [...prev.data7A, moreData.data7A[0]],
        total: [...prev.total, moreData.total],
      }));
    }
  }, [moreData]);
  useEffect(() => {
    if (sevenAData) {
      let tempYear = sevenAData?.data7A?.map((ob) => ob?.F_YEAR);
      setYearsInData(tempYear);
    }
  }, [sevenAData]);

  return (
    <div className="">
      <div className="row   me-2 ms-2">
        <CustomPageNevBtn
          setActivePage={setActivePage}
          activePage={activePage}
          pages={["CH Weight", "Wagon", "Summary Reports"]}
        />
      </div>
      {loading && <Loading />}
      {sevenAData ? (
        <div className="sticky-controller">
          <SAController
            setStatus={setStatus}
            data={sevenAData}
            setFilteredSevenA={setFilteredSevenA}
            openStates={openStates}
            setOpenStates={setOpenStates}
          />
        </div>
      ) : (
        "No Data Found"
      )}

      <div
        onClick={() => {
          setOpenStates({
            Year: false,
            "Group Commodity": false,
            "Sub Group Commodity": false,
            Commodity: false,
            Month: false,
            "From Station": false,
            "To Station": false,
          });
        }}
      >
        {activePage === "Wagon" ? (
          <Wagon data={FilteredSevenA} status={status} />
        ) : null}
        {activePage === "CH Weight" ? (
          <CHWeight data={FilteredSevenA} status={status} />
        ) : null}
        {activePage === "Summary Reports" && (
          <SevenASummary
            data={FilteredSevenA}
            setMoreData={setMoreData}
            availableYear={sevenAData.fin_year}
            yearsInData={yearsInData}
          />
        )}
      </div>
    </div>
  );
};

export default SevenALoadingMaster;
